import classNames from 'classnames';
import { PropsWithChildren } from 'react';

interface IProps {
    title?: string;
    className?: string;
    backgroundsurface?: SupportedBackgroundColor;
}

const FrecuentlyQuestions = ({
    title = '',
    className = '',
    children,
    backgroundsurface = 'bg-surface-100',
}: PropsWithChildren<IProps>) => {
    return (
        <div className={classNames(backgroundsurface, 'py-10 pb-5')}>
            <div className={classNames('max-w-screen-md', 'mx-auto')}>
                <div className="lg:mb-12 mb-6">
                    <h2
                        className={classNames(
                            'text-center font-poppins font-bold text-surface-primary-darker text-32 md:text-40 lg:text-48 leading-40 md:leading-56 lg:leading-64'
                        )}
                    >
                        {title}
                    </h2>
                </div>
                <div className="mb-10">
                    <ul className={className}>{children}</ul>
                </div>
            </div>
        </div>
    );
};

export default FrecuentlyQuestions;
